const capitalize = value => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.toUpperCase();
};

export default capitalize;
